<template>
    <div class="home-page" v-if="!user">
        <div class="animation-part" v-if="!initialAnimation">
            <div class="flex column items-center justify-center gap-20 h-full">
                <div class="header font-size-36px bold letter-spacing text">
                    KYCWISE
                </div>
                <div class="text font-size-16" style="color:rgb(107 114 128)">
                    Secure Compliance Solutions
                </div>

                <div class="logo-animation" @click="removeAnimation()">
                    <svg class="w-8 h-8 text-blue-600 group-hover:text-white transition-colors duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                    <span class="pulsar">
                    </span>
                </div>
                <div class="font-size-14" style="color:rgb(156 163 175)">
                    CLICK TO ENTER
                </div>
            </div>
        </div>
        <div id="home_section" class="section flex items-center justify-center column gap-20 top-section" >
            <div class="text-center font-size-60px" style="font-weight: 800; max-width: 800px; line-height: 1;">
                KYC Made Simple with KYCWise
            </div>
            <div class="font-size-20 text-center top-section-subtext" >
                Automate your internal your Internal AML/CFT/CPF control processes and ensure adherence to global standards.
            </div>
            <div class="flex gap-10">
                <button @click="goToSection('pricing')" class="button font-size-16" style="width: 150px;">Get Started</button>
                <button @click="goToSection('features')" class="button transparent font-size-16" style="width: 150px; height: 50px;">Learn more</button>
            </div>
        </div>
        
        <div id='about' class="section flex items-center justify-center column gap-20">
            <div class="text-center font-size-36px" style="font-weight: 800; max-width: 800px; line-height: 1;">
                About KYCWise
                <div class="dividor-header"></div>
            </div>
            <div class="font-size-18 text-center top-section-subtext mb-30" >
                We're dedicated to helping organizations streamline their compliance operations through innovative technology solutions.
            </div>
            <div class="flex gap-40 blocks">
                <div class="block flex column align-center gap-20 flex-1 ">
                    <div class="icon-section">
                        <img src="@/assets/security.svg" style="width: 25px; height: 25px;">
                    </div>
                    <div class="block-header bold font-size-18">Secure & Reliable</div>
                    <div class="block-description">Built with enterprise-grade security features to protect your sensitive data at all times.</div>
                </div>
                <div class="block flex column align-center gap-20 flex-1">
                    <div class="icon-section">
                        <img src="@/assets/lump.svg" style="width: 25px; height: 25px;">
                    </div>
                    <div class="block-header bold font-size-18">Global Standards</div>
                    <div class="block-description">Designed to meet international compliance requirements.
                        <!-- including GDPR, HIPAA, and ISO standards. -->
                    </div>
                </div>
                <div class="block flex column align-center gap-20 flex-1">
                    <div class="icon-section">
                        <img src="@/assets/lighning.svg" style="width: 25px; height: 25px;">
                    </div>
                    <div class="block-header bold font-size-18">Real-time Updates</div>
                    <div class="block-description">Stay ahead with instant notifications about regulatory changes and compliance deadlines.</div>
                </div>
            </div>
        </div>
        <div id='compliance' class="section approach flex items-center justify-center column gap-20 darker">
            <div class="text-center font-size-36px" style="font-weight: 800; max-width: 800px; line-height: 1;">
                Our Compliance Approach
                <div class="dividor-header"></div>
            </div>
            <div class="font-size-18 text-center top-section-subtext mb-30" >
                KYCWise provides a comprehensive framework that adapts to various industry-specific regulations and standards.
            </div>
            <div class="flex gap-40 blocks">
                <div class="approach-block">
                    <div class="top-line blue"></div>
                    <div class="block-content flex column align-start gap-10 p-20">
                        <div class="block-header bold font-size-20">Automated Audits</div>
                        <div class="block-description text-left">Our system automatically performs regular audits across your organization's digital infrastructure.</div>
                        <div class="points flex column gap-5px align-start">
                            <div class="point flex items-center font-size-16">
                                <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                                Continuous monitoring
                            </div>
                            <div class="point flex items-center font-size-16">
                                <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                                Customizable schedules
                            </div>
                            <div class="point flex items-center font-size-16">
                                <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                                Instant alerts
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="approach-block">
                    <div class="top-line purple"></div>
                    <div class="block-content flex column align-start gap-10 p-20">
                        <div class="block-header bold font-size-20">Regulated Framework</div>
                        <div class="block-description text-left">Support integration with multiple regulatory frameworks across different jurisdictions.</div>
                        <div class="points flex wrap gap-10">
                            <div class="point-square">
                                <div class="point-header font-size-16 bold">GDPR</div>
                                <div class="point-description font-size-14">Data Protection</div>
                            </div>
                            <div class="point-square">
                                <div class="point-header font-size-16 bold">HIPAA</div>
                                <div class="point-description font-size-14">Healthcare</div>
                            </div>
                            <div class="point-square">
                                <div class="point-header font-size-16 bold">ISO 27001</div>
                                <div class="point-description font-size-14">Security</div>
                            </div>
                            <div class="point-square">
                                <div class="point-header font-size-16 bold">PCI DSS</div>
                                <div class="point-description font-size-14">Payments</div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <div id="features" class="section flex items-center justify-center column gap-20">
            <div class="text-center font-size-36px" style="font-weight: 800; max-width: 800px; line-height: 1;">
                Key Features
                <div class="dividor-header"></div>
            </div>
            <div class="font-size-18 text-center top-section-subtext mb-30 mt-10" >
                Discover how KYCWise's advanced features can transform your transaction monitoring and reporting processes.
            </div>
            <div class="flex gap-30 blocks features">
                <!-- <div class="block flex column align-center gap-10 flex-1 ">
                    <div class="icon-section">
                        <img src="@/assets/documents.svg" style="width: 25px; height: 25px;">
                    </div>
                    <div class="block-header bold font-size-20">Document Management</div>
                    <div class="block-description">Centralize documents with version control and automated retention policies.</div>
                </div>
                <div class="block flex column align-center gap-10 flex-1">
                    <div class="icon-section">
                        <img src="@/assets/ss.svg" style="width: 25px; height: 25px;">
                    </div>
                    <div class="block-header bold font-size-20">Sanction Screening</div>
                    <div class="block-description">Screen individuals against global watchlists in real time.</div>
                </div>
                <div class="block flex column align-center gap-10 flex-1">
                    <div class="icon-section">
                        <img src="@/assets/dd.svg" style="width: 25px; height: 25px;">
                    </div>
                    <div class="block-header bold font-size-20">Customer Due Diligence</div>
                    <div class="block-description">Automate client verification with risk-based checks and identity validation.</div>
                </div> -->
                <div class="block flex column align-center gap-10 flex-1">
                    <div class="icon-section">
                        <img src="@/assets/transaction-monitoring.svg" style="width: 25px; height: 25px;">
                    </div>
                    <div class="block-header bold font-size-20">Transaction Monitoring</div>
                    <div class="block-description">Bulk reporting tool for objective threshold reporting to FIU Curacao.</div>
                </div>
            </div>
        </div>

        <div id='pricing' class="section flex items-center justify-center column gap-20 darker">
            <div class="text-center font-size-36px" style="font-weight: 800; max-width: 800px; line-height: 1;">
                KYCWise Pricing
                <div class="dividor-header"></div>
            </div>
            <div class="font-size-18 text-center top-section-subtext mb-30" >
                Transparent and scalable pricing 
                 <!-- for automated sanction list checks and compliance tools. -->
            </div>
            <div class="flex gap-30 blocks pricing">
                <!-- <div class="block flex column align-center gap-10 flex-1 pricing-block">
                    <div class="flex column align-center gap-10">
                        <div class="block-header bold font-size-20">Sanction Screening</div>
                        <div class="price font-size-30 flex">€5 <div class="item-service">/report</div></div>
                        <div class="block-description">Perfect for occasional screening needs.</div>
                        <button class="button font-size-16 w-full" @click="signup()">Sign Up for Free</button>
                    </div>
                    <div class="points flex column gap-5px align-start darker">
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            Instant match detection
                        </div>
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            Global watchlist coverage
                        </div>
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            PDF reports included
                        </div>
                    </div>
                </div> -->

                <!-- <div class="block flex column align-center gap-10 flex-1 pricing-block">
                    <div class="flex column align-center gap-10">
                        <div class="block-header bold font-size-20">Document Mgmt</div>
                        <div class="price font-size-30 flex">€2.99<div class="item-service">/month</div></div>
                        <div class="block-description">Centralize and manage documents securely.</div>
                        <button class="button font-size-16 w-full" @click="signup()">Sign Up for Free</button>
                    </div>
                    <div class="points flex column gap-5px align-start darker">
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            Version control
                        </div>
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            Audit trail & tracking
                        </div>
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            Role-based access
                        </div>
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            Retention policies
                        </div>
                    </div>
                </div> -->

                <div class="block flex column align-center gap-10 flex-1 pricing-block">
                    <div class="flex column align-center gap-10">
                        <div class="block-header bold font-size-20">Transaction Monitoring</div>
                        <div class="price font-size-30 flex">€250<div class="item-service">/monthly subscription</div></div>
                        <div class="price font-size-30 flex">€5.00<div class="item-service">/per report generated</div></div>
                        <div class="block-description">Monitoring reporting tool.</div>
                        <button class="button font-size-16 w-full" @click="signup()">Sign Up for Free</button>
                    </div>
                    <div class="points flex column gap-5px align-start darker">
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            Sign up for free 
                        </div>
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            Bulk Transaction Reporting 
                        </div>
                    </div>
                </div>
                
                <!-- <div class="block flex column align-center gap-10 flex-1 pricing-block">
                    <div class="flex column align-center gap-10">
                        <div class="block-header bold font-size-20">Customer Due Diligence</div>
                        <div class="price font-size-30 flex">€20<div class="item-service">/report</div></div>
                        <div class="block-description">High-risk clients and full CDD automation.</div>
                        <button class="button font-size-16 w-full" @click="signup()">Sign Up for Free</button>
                    </div>
                    <div class="points flex column gap-5px align-start darker">
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            Unlimited Users
                        </div>
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            Full CDD automation
                        </div>
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            Onboarding workflow
                        </div>
                        <div class="point flex items-center font-size-16">
                            <img src="@/assets/checkmark_.svg" style="width: 20px; height: 20px; margin-right: 10px;">
                            Dedicated Manager
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
        <div id='contact' class="section contact flex items-center justify-center column gap-20 darker">
            <div class="text-center font-size-36px" style="font-weight: 800; max-width: 800px; line-height: 1;">
                Get in Touch
                <div class="dividor-header"></div>
            </div>
            <div class="font-size-18 text-center top-section-subtext mb-30 " >
                Have questions or want to learn more? Reach out to our team today.
            </div>
            <div class="flex gap-40 blocks contact-block-wrap ">
                <div class="contact-block border-box">
                    <div class="header font-size-24 bold">Contact Us</div>
                    <div class="contact-form-body w-full">
                        <InpComponent
                            label="First & Last Name"
                            type="text"
                            
                            :key_ref="'name'"
                            :value="messageInfo.name"
                            :error="''"
                            @inputChange="inputChangeFunc"
                        ></InpComponent>

                        <InpComponent
                            label="Email"
                            type="email"
                            
                            :key_ref="'email'"
                            :value="messageInfo.email"
                            :error="''"
                            @inputChange="inputChangeFunc"
                            >
                        </InpComponent>

                        <InpComponent
                            label="Company Name"
                            type="text"
                            
                            :key_ref="'companyName'"
                            :value="messageInfo.companyName"
                            :error="''"
                            @inputChange="inputChangeFunc"
                        ></InpComponent>

                        <div class="question-label">Your question</div>
                        <textarea v-model="messageInfo.message"></textarea>

                        <button class="submit-button" @click="sendInfo">Send Message</button>
                    </div>
                    
                </div>
                <div class="contact-block border-box">
                    <div class="header font-size-24 bold">Our Information</div>
                    <div class="content flex column gap-30">
                        <div class="info-item flex row gap-10">
                            <div class="img">
                                <img src="@/assets/location-blue.svg" style="width: 30px; height: auto;">
                            </div>
                            <div class="text-info flex column align-start">
                                <div class="contant-header bold font-size-16">Address</div>
                                <div class="contact-description text-left">E-Commerce Park Vredenberg Unit D.11, Heelsumstraat 51</div>
                                <div class="contact-description text-left">Willemstad, Curaçao</div>
                            </div>
                        </div>
                        
                        <!-- <div class="info-item flex row gap-10">
                            <div class="img">
                                <img src="@/assets/call-blue.svg" style="width: 30px; height: auto;">
                            </div>
                            <div class="text-info flex column align-start">
                                <div class="contant-header bold font-size-16">Phone</div>
                                <div class="contact-description">(5999) 512-1496</div>
                            </div>
                        </div> -->

                        <div class="info-item flex row gap-10">
                            <div class="img flex justify-center" style="width: 30px; ">
                                <img src="@/assets/email.svg" style="width: 20px; height: auto;">
                            </div>
                            <div class="text-info flex column align-start">
                                <div class="contant-header bold font-size-16">Email</div>
                                <div class="contact-description">amllink.info@gmail.com</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer :homepage="true"/>
    </div>
    <div v-else class="p-20 logged-in-view">
        <!-- <div class="flex items-center justify-center column gap-20 top-section" >
            <div class="text-center font-size-36px" style="font-weight: 800; max-width: 800px; line-height: 1;">
                Welcome back, {{name}}!
            </div>
        </div> -->
        <div class="intro flex column gap-20">
            <div class="top-section-home">
                <div class="image-section-top"></div>
                <div class="top-texts">
                    <div class="header-text font-size-36px">Hi, {{name}}!<br> Welcome to the KYC Wise Platform!</div>
                    <div class="small-text mt-10">Discover our enhanced FIU reporting tool and get access to other modules</div>
                </div>
            </div>
            <div class="font-size-22 text-left">Our Products</div>   
            <div class="cards">
                <div class="card">
                    <div class="img-section">
                        <img src="@/assets/transaction-monitoring.png">
                    </div>
                    <div class="card-texts">
                        <div class="card-header">Transaction Monitoring</div>
                        <div class="card-description">
                            <p>Comprehensive tool to help speed up FIU's objective reporing supporting bulk conversions</p>
                            <p><b>Coverage:</b> Objective bank transactions </p>
                            <p><b>Comming soon:<br>
                                Objective reporting on:</b></p>
                            <p>- Player deposit<br>
                            - Payout of winnings<br>    
                            - PSP to bank tranactions<br>
                            </p>
                        
                            
                        </div>
                    </div>
                </div>
                <div class="card opacity-50">
                    <div class="img-section">
                        <img src="@/assets/kyc-img2.png">
                    </div>
                    <div class="card-texts">
                        <div class="card-header">Document Management</div>
                        <div class="card-description">
                            <p>Centralize documents with version control and automated retention policies</p>
                            <p>Coomming soon...</p>
                        </div>
                    </div>
                </div>
                <div class="card opacity-50">
                    <div class="img-section">
                        <img src="@/assets/sanction-screaning.png">
                    </div>
                    <div class="card-texts">
                        <div class="card-header">Sanction Screening</div>
                        <div class="card-description">
                            <p>Screen individuals against global watchlists in real time.</p>
                            <p>Coomming soon...</p>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script setup>
import { ref, computed, onMounted, watch, defineEmits } from 'vue'
import store from '../store';
import InpComponent from '@/components/InpComponent.vue';
import Footer from '@/components/Footer.vue'

import API from '../api/index.js'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter();
const route = useRoute();

const to = ref(route.query.to)

const initialAnimation = computed(() => store.state.animationPassed)
const userInformation = computed(() => store.state.userInformation)
const user = computed(() => store.state.user)
function inputChangeFunc(event) {
    const event_type = event[0];
    const event_value = event[1];
    messageInfo.value[event_type] = event_value;
}


const name = computed( () => {
    if (userInformation.value.rentity_branch) {
        return userInformation.value.rentity_branch;
    } else {
        return user.value.username;
    }
})

const messageInfo = ref({
    name: '',
    email: '',
    companyName: '',
    message: ''
})
function goToSection(sectionId) {
    store.dispatch('goToSection', { sectionId: sectionId })
}
function signup() {
    router.push('/register')
}


onMounted(() => {
    if (to.value) {
        let element = document.querySelector(`#${to.value}`);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }
})

async function sendInfo() {
  if (!messageInfo.value.name.trim() || !messageInfo.value.email.trim() || !messageInfo.value.companyName.trim() || !messageInfo.value.message.trim()) {
    alert('Please fill out all fields')
    return;
  }
  let success = await API.sendContactInfoText({
    name: messageInfo.value.name,
    email: messageInfo.value.email,
    companyName: messageInfo.value.companyName,
    message: messageInfo.value.message
  })
  if (success.message == 'Message sent successfully') {
    store.dispatch('addNotification', {
      type: 'success',
      text: 'Message sent successfully'
    })
  } else {
    store.dispatch('addNotification', {
      type: 'error',
      text: 'Failed to send message'
    })
  }
   

}
function removeAnimation(){
    store.dispatch('setValue', { key: 'animationPassed', value: true })
    document.querySelector('.home-page').classList.add('animation-fade-out');
    setTimeout(() => {
        let homeSection = document.querySelector('.home-page')
        if (homeSection) {
            homeSection.classList.remove('animation-fade-out');
        }
    }, 1000);

}



</script>


<style scoped lang="scss">
    
    .logged-in-view {
        padding-top: 40px;
        margin: auto;
        max-width: 1070px;
    }

    .cards {
        display: flex;
        gap: 20px;
        flex-wrap: wrap;
    }
    .card {
        max-width: 328px;
        min-width: 280px;
        flex: 1;
        background-color: white;
        border: 1px solid var(--border-color);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-radius: 10px;
        overflow: hidden;
    }
    .image-section-top {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('@/assets/top-cover_.png');
        background-repeat: no-repeat;
        background-position: right;
        background-size: cover;
        filter: brightness(0.5)

    }
    .top-texts {
        z-index: 3;
        position: relative;
        color: white;
    }
    .img-section {
        background-color: rgb(249 250 251);
        height: 120px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        filter: brightness(0.7);
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .card-texts {
        padding: 20px;
        text-align: left;
    }
    .card-header {
        font-size: 20px;
    }
    .top-section-home {
        position: relative;
        background-color: white;
        padding: 20px;
        text-align: left;
        border: 1px solid var(--border-color);
        border-radius: 10px;
        height: 177px;
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
      
    }
    .opacity-50 {
        opacity: 0.5;
    }
    .header-text {
        line-height: 2.45rem;
    }
    .home-page {
        box-sizing: border-box;
        background-color: rgb(255 255 255);
    }
    .top-section-subtext {
        color: rgb(75 85 99);
        max-width: 770px;
    }
    .links a {
        color: rgb(75 85 99);
        transition: all 0.3s ease;
        &:hover {
            color: var(--primary-color);
        }
    }
    .dividor-header {
        width: 100px;
        height: 4px;
        background-color: var(--primary-color);
        margin: 20px auto 0 auto;
    } 

    .block {
        min-width: 200px;
        background-color: rgb(249 250 251);
        padding: 20px;
        border-radius: 10px;
        box-shadow:  0 1px 2px 0 rgb(0 0 0 / 0.05);
        transition: all 0.3s ease;
        position: relative;
        top: 0;
        &:hover {
            top: -10px;
            box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
        }
    }
 
    .icon-section {
        background-color: rgb(219 234 254);
        width: 48px;
        height: 48px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .block-description {
        color: rgb(75 85 99);
        font-size: 16px;
    }
    .blocks {
        max-width: 1024px;
        padding: 20px;
        box-sizing: border-box;
        display: flex;
        flex-wrap: wrap;
    }
    .features, .pricing {
        max-width: 1152px;
    }
    .section {
        padding: 64px 0;
        padding-left: 20px;
        padding-right: 20px;
    } 
  
    .top-section {
        height: calc(100vh - 128px);
    }
    .approach-block {
        flex: 1;
        background-color: white;
        // padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow:  0 1px 2px 0 rgb(0 0 0 / 0.05);
        transition: all 0.3s ease;
        position: relative;
        top: 0;
        &:hover {
            top: -10px;
            box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
        }
    } 
    .point-square {
        background-color: rgb(249 250 251);
        padding: 10px;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-width: 200px;
    }
    .point-description {
        color: rgb(75 85 99);
    }

    .top-line {
        width: 100%;
        height: 8px;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        &.blue {
            background-color: var(--primary-color);
        }  
        &.purple {
            background-color: rgb(147 51 234)
        }
    } 
    .pricing-block {
        background-color: white;
        padding: 0px;
        border-radius: 10px;
        box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);

        .block-description {
            margin-bottom: 20px;
        }
        > div {
            padding: 24px;
            width: 100%;
            box-sizing: border-box;
        }
    }
    .price {
        display: flex;
        align-items: baseline;
        font-weight: 600;
    }
    .item-service {
        font-size: 14px;
        color: rgb(75 85 99);
        font-weight: 500;
    }
    .contact-block {
        background-color: white;
        flex: 1;
        padding: 24px;
        border-radius: 10px;
        width: 900px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    }
    .question-label {
        width: fit-content;
        background-color: white;
        font-size: 11px;
        position: relative;
        padding: 0 5px;
        bottom: -10px;
        left: 5px;
    }

    textarea {
        width: 95%;
        resize: none;
        height: 150px;
        border: 1px solid var(--border-color);
        border-radius: 5px;
        padding: 10px;
        margin-bottom: 20px;
        &:focus {
            outline: none;
            border: 1px solid var(--primary-color);
        }
    }
    .contact-description {
        color: rgb(75 85 99);
        
        font-size: 14px;
    }
    .animation-part {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: white;
        z-index: 9999;
    }
    .letter-spacing {
        letter-spacing: 5px;
    }
    .logo-animation {
        position: relative;
        cursor: pointer;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid var(--primary-color);
        transition: all 0.3s ease;
        &:hover {
            background-color: var(--primary-color);
            svg {
                stroke: white;
                fill: white;
            }
        }
        svg {
            stroke: var(--primary-color);
            fill: var(--primary-color);
            width: 30px;
            height: 30px;
            animation: bounce 2s infinite;
        }
        .pulsar {
            position: absolute;
            width: 100px;
            height: 100px;
            border-radius: 50%;
            // background-color: var(--primary-color);
            border-radius: 50%;
            border: 1px solid var(--primary-color);
            animation: pulsate 1s infinite cubic-bezier(0, 0, 0.2, 1);
            opacity: 0.5;
        }

    }
    .darker {
        background-color: rgb(249 250 251)
    }
    .footer-block {
        width: 100%;
        margin-left: 50px;
    }
    @keyframes pulsate {
        0% {
            transform: scale(1);
            opacity: 1;
        }
        100% {
            transform: scale(2);
            opacity: 0;
        }
    }
    .animation-fade-out {
        animation: fadeOut 1s forwards;
    }
    @keyframes fadeOut {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .animation-part .text {
        line-height: 1;
        animation: textFade 2.5s ease-in-out infinite;
    }
    @keyframes textFade {
        0%, 100% {
            opacity: 1;
        }
        50% {
            opacity: 0.5;
        }
    }

    @media screen and (max-width: 1080px) {
        .contact-block-wrap {
            flex-direction: column;
        }
        .contact-block {
            width: 90vw;
        }
        .features, .pricing {
            max-width: 100%;
        }
    }

</style>